import { State } from './state'

export const computeScreenCanBeLocked = (state: State) => (screen: string) =>
  state.lockableScreens.includes(screen)

export const computeIsScreenLocked = (state: State) => (screen: string) =>
  state.lockedScreens.includes(screen)
